/* 
plugin name:jquery.wg_browser-detection - v0.1.0 
time: 2013-08-27 11:08 
*/
/*
 The MIT License

 Copyright (C) 2013 Wargaming.net

 Permission is hereby granted, free of charge, to any person obtaining a copy of
 this software and associated documentation files (the "Software"), to deal in
 the Software without restriction, including without limitation the rights to
 use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 of the Software, and to permit persons to whom the Software is furnished to do
 so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
/*global define */
/**
 * module pattern for jquery plugin usage with requirejs
 */
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        /*jshint unused:false*/
        define(['jquery'], factory);
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function($, undefined) {
    'use strict';

/*jshint unused:false*/
var BrowserDetection = (function($, navigator) {
    'use strict';
    var matched, browser = {};

    $.uaMatch = function(ua) {
        var match, browserMatch, webkitMatch, mobileMatch;
        ua = ua.toLowerCase();

        //define a regexp to detect browser, its version and additional information
        match = /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
            /(chromium) ((\d+)?[\w\.]+)/.exec(ua) ||
            /(yabrowser)\/((\d+)?[\w\.]+)/.exec(ua) ||
            /(chrome)[ \/]([\w.]+)/.exec(ua) ||
            /(kindle)\/((\d+)?[\w\.]+)/.exec(ua) ||
            ua.indexOf('compatible') < 0 && /(firefox)\/((\d+)?[\w\.-]+)/.exec(ua) ||
            /(iemobile)(?:browser)?[\/\s]?((\d+)?[\w\.]*)/.exec(ua) ||
            /(msie) ([\w.]+)/.exec(ua) ||
            /(trident)\/.+rv[^\w]+([\w\.]+)/.exec(ua) ||
            /(android)[\/\s-]?([\w\.]+).*?version\/([\w\.]+).+?(mobile)\s+(safari)/.exec(ua) ||
            /version\/((\d+)?[\w\.]+).+?(mobile)\/\w+\s(safari)/.exec(ua) ||
            /version\/((\d+)?[\w\.]+).+?(safari)/.exec(ua) ||
            /version\/.+?\/\w+\s(safari)/.exec(ua) ||
            /(mozilla)\/((\d+)?[\w\.]+).+gecko/.exec(ua);  //catch all gecko like browsers

        webkitMatch = /webkit/.exec(ua);
        mobileMatch = /mobile/.exec(ua);

        if (match === null) {
            return {};
        }

        browserMatch = {
            browser: match[1] || '',
            version: match[2] || '0',
            mobile: mobileMatch !== null ? true : false,
            webkit: webkitMatch !== null ? true : false
        };

        if (match[1] === 'android') {
            browserMatch.browser = match[5];
            browserMatch.version = match[3];
            browserMatch.android = true;
            browserMatch.osVersion = match[2];
        } else if (match[4] === 'safari') {
            browserMatch.browser = match[4];
            browserMatch.version = match[1];
        } else if (match[3] === 'safari') {
            browserMatch.browser = match[3];
            browserMatch.version = match[1];
        } else if (browserMatch.browser === 'kindle') {
            browserMatch.mobile = true;
        } else if (match[1] === 'trident') {
            browserMatch.browser = 'msie';
        }

        return browserMatch;
    };

    // Don't clobber any existing jQuery.browser in case it's different
    if (!$.browser) {
        matched = $.uaMatch(navigator.userAgent);

        if (matched.browser && matched.browser !== '') {
            browser[matched.browser] = true;
            browser.version = matched.version;
            browser.mobile = matched.mobile;
            browser.webkit = matched.webkit;
        }

        if (matched.android) {
            browser.android = true;
            browser.osVersion = matched.osVersion;
        }

        $.browser = browser;
    }

    return $.browser;


})($, navigator);

return BrowserDetection;
}));
